export default {

    groupId: null, 

    /**
     * 
     * @param {*} groupId 
     * @param {*} data 
     * @returns 
     */
     getData(groupId, data) {
        this.groupId = groupId;
        return {
            id: groupId,
            campaigns: this.getCampaignData(data)
        }
    },

    getDataViewed(data) {
        return {
            id: this.groupId,
            campaign: data.campaignId
        }
    },

    getCampaignData(data){
        let list = [];
        if(!data || data.hasOwnProperty('campaigns') && data.campaigns.length){
            data.campaigns.forEach( item => {
                list.push({
                    id: item.campaignId,
                    type: item.type,
                });
            })
            console.log(data.campaigns);
        }
        return list;
    }
};